import type { Appointment, AppointmentCategory } from "../types/garage/planning";

/**
 * A reception column is a single agenda (mirrored to ServiceBox): two RDV cannot
 * share the same slot on it. Returns the appointment already occupying the target
 * slot on the same column/date, or null when the slot is free.
 */
export function receptionSlotTaken(
  appointments: Appointment[],
  params: {
    category: AppointmentCategory;
    date: string;
    startHour: number;
    durationHours: number;
    excludeId?: string;
  },
): Appointment | null {
  const end = params.startHour + params.durationHours;
  for (const a of appointments) {
    if (a.id === params.excludeId) continue;
    if (a.category !== params.category) continue;
    if ((a.date || "") !== params.date) continue;
    if (a.allDay) continue;
    const aEnd = a.startHour + a.durationHours;
    if (params.startHour < aEnd && a.startHour < end) return a;
  }
  return null;
}
